import React, {useCallback, useEffect} from "react";

export const useDesktop = () => {
    const [isDesktop, setDesktop] = React.useState(window.innerWidth > 768);

    const listener = useCallback(() => {
        const val = window.innerWidth > 768;
        if(val !== isDesktop) {
            setDesktop(val);
        }
    }, [isDesktop])
    useEffect(() => {
        window.addEventListener("resize", listener);
    }, [])


    return isDesktop;
}
